<prlw-mobile-overlay-card-ui
  label="Выбор продукта"
  [showDoneButton]="false"
  (eventClickX)="eventClickX.emit()"
  (eventClickMobileButton)="eventClickX.emit()"
>
  <ng-container body>
    <prlw-mobile-list-section-ui
      label="Мои продукты"
      [items]="selectedItems"
      (eventIconClick)="eventProductGroupUnselected.emit($event)"
      (eventClick)="eventSelectProductGroup.emit($event)"
    ></prlw-mobile-list-section-ui>
    <prlw-mobile-list-section-ui
      label="Другие продукты"
      [items]="otherItems"
      (eventIconClick)="eventProductGroupSelected.emit($event)"
      (eventClick)="eventSelectProductGroup.emit($event)"
    ></prlw-mobile-list-section-ui>
  </ng-container>
</prlw-mobile-overlay-card-ui>
